import { format } from "date-fns";
import { Form, Formik } from 'formik';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import BackButton from '../../components/BackButton';
import { Loader } from '../../components/Loader';
import { ensure, notificationChoreType, scheduleTypes, when_Automated } from '../../constants';
import { EVO } from '../../EVO';
import { withEnsure } from '../../redux/ensure';
import * as actions from "../../redux/notificationchores";
import './NotificationChoreHistory.css';
import { NCDSummary } from './Summary';

const NCH = props => {
    useEffect(() => {
        let postEnsure = ensure.appointmentCategory + ensure.practitioner + ensure.appointmentModelProperties + ensure.smsCredits + ensure.business + ensure.billableItems + ensure.sexes + ensure.medicalAlerts + ensure.ptProducts;
        if (props.notificationChoreType === notificationChoreType.Email) {
            postEnsure += ensure.cmEmails;
        }

        props.ensure(postEnsure);
        const id = EVO.getParamsId(props);
        const page = EVO.getParamsId(props, 'page');
        props.fetchnotificationchorehistory(id, page);
    }, []);

    const renderTable = () => {
        return !props.notificationchorehistory.schedules ? null : <div>
            {title(props.notificationchorehistory.chore)}
            <div className='nch-history-table'>
                <div className="nch-history-header" >
                    <div className="nch-history-row-title">Date{props.notificationchore && props.notificationchore.scheduleTypeId === scheduleTypes.Recurring.value && <span className="nch-history-title-small">(Click a row for more details)</span>}</div>
                    <div className="nch-history-row-title">Recipients</div>
                </div>
                {props.notificationchorehistory.schedules.map(his => <Row key={his.sentDateTime} item={his} />)}
            </div>
        </div>
    }

    const title = nch => {
        return !nch ? null : <div className="nc-title">{EVO.getPropertyNameFromObjectValue(scheduleTypes, nch.scheduleTypeId)} - {nch.name}</div>
    }

    return (
        <div className="ncd-history">
            <Loader loading={props.loading}>
                <BackButton />
                <div className="nc-title">{props.notificationchore.notificationChoreType === notificationChoreType.Sms ? 'SMS Summary' : 'Transactional Email Summary'}</div>
                <Formik
                    initialValues={props.notificationchore}
                    onSubmit={() => { }}>
                    {() =>
                        <Form>
                            <NCDSummary ncd={props.notificationchore} />
                        </Form>
                    }
                </Formik>
                {renderTable()}
            </Loader>
        </div>
    );
}

const Row = ({ item }) => {
    const [expanded, setExpanded] = useState(false);
    const chore = useSelector(s => s.notificationchores.notificationchore);
    return <div className="nch-history-item">
        <div className="nch-history-row" onClick={() => setExpanded(!expanded)}>
            <div>{item.sentDateTime ? format(new Date(item.sentDateTime), (item.showTime ? 'do MMM yyyy hh:mm a' : 'do MMM yyyy')) : null}</div>
            <div>{item.notificationsSent}</div>
        </div>
        {expanded && EVO.any(item.items) && <div>
            <div className="nch-history-row">
                <div className="nch-history-row-title">Time</div>
                <div className="nch-history-row-title">Patient</div>
                <div className="nch-history-row-title">{(chore.whenAutomatedId === when_Automated.AfterInvoiceCreated.value || chore.whenAutomatedId === when_Automated.AfterInvoiceClosed.value) ? 'Invoice' : 'Appointment'}</div>
            </div>
            {item.items.map(i => <div key={i.appointmentId} className="nch-history-row">
                <div>{format(new Date(i.sent), 'h:mm a')}</div>
                {i.patientId && <div><ClinikoLink relativePath={`/patients/${i.patientId}`} name={i.patientId} /></div>}
                <div>{(chore.whenAutomatedId === when_Automated.AfterInvoiceCreated.value || chore.whenAutomatedId === when_Automated.AfterInvoiceClosed.value) ? <ClinikoLink relativePath={`/invoices/${i.appointmentId}`} name={i.appointmentId} />
                    : <ClinikoLink relativePath={`/appointments/${i.appointmentId}`} name={i.appointmentId} />}</div>
            </div>)}
        </div>}
    </div>
};

const ClinikoLink = ({ relativePath, name }) => {
    const chore = useSelector(s => s.notificationchores.notificationchorehistory);
    if (!chore.shard || !chore.subdomain) {
        return null;
    }
    return <a className="nch-history-link" href={`https://${chore.subdomain}.${chore.shard}.cliniko.com${relativePath}`} target="_blank" rel="noopener noreferrer">{name}</a>;
};

const mapStateToProps = ({ notificationchores }) => ({
    notificationchorehistory: notificationchores.notificationchorehistory,
    notificationchore: notificationchores.notificationchore,
    loading: notificationchores.loading,
    error: notificationchores.error
});

export default connect(mapStateToProps, withEnsure(actions))(withRouter(NCH));

//Patient URL: https://peptalkr1.au1.cliniko.com/patients/67947950/
//Appointment URL https://peptalkr1.au1.cliniko.com/appointments/261656394
//Invoice URL: https://peptalkr1.au1.cliniko.com/invoices/114655461


// WEBPACK FOOTER //
// ./src/pages/NotificationChore/NotificationChoreHistory.js